<script>
import options from './StreamDonationOverviewHorizontal.options'
import StreamDonationOverviewNewDonation from '../StreamDonationOverviewNewDonation/StreamDonationOverviewNewDonation.vue'
import StreamDonationOverviewPreviousDonation from '../StreamDonationOverviewPreviousDonation/StreamDonationOverviewPreviousDonation.vue'
export default {
  ...options,
  components: { StreamDonationOverviewNewDonation, StreamDonationOverviewPreviousDonation }
}
</script>

<template>
  <article
    class="kb-stream-donation-overview-horizontal"
    :class="`kb-stream-donation-overview-horizontal--${variation}`"
  >
    <div class="kb-stream-donation-overview-horizontal__raised">
      <span class="kb-stream-donation-overview-horizontal__raised-label">Indsamlet:</span>
      <span class="kb-stream-donation-overview-horizontal__raised-amount">{{ totalAmount }} kr.</span>
    </div>

    <div class="kb-stream-donation-overview-horizontal__progress-section">
      <div class="kb-stream-donation-overview-horizontal__progress-header">
        <h2 class="kb-stream-donation-overview-horizontal__title">{{ name }}</h2>
        <span class="kb-stream-donation-overview-horizontal__goal">
          <span class="kb-stream-donation-overview-horizontal__goal-label">Mål: </span>
          <span class="kb-stream-donation-overview-horizontal__goal-value">{{ targetAmount }} kr.</span>
        </span>
      </div>
      <div class="kb-stream-donation-overview-horizontal__progress">
        <div
          class="kb-stream-donation-overview-horizontal__progress-fill"
          :style="`width: ${progressPercent}%;`"
        ></div>
      </div>
    </div>

    <div class="kb-stream-donation-overview-horizontal__donations">
      <template v-for="donation in visibleDonations" :key="donation.id">
        <StreamDonationOverviewNewDonation
          v-if="donation.kind === 'new'"
          :donation-style="donationStyle"
          :amount="donation.amount"
          :donor-name="donation.donorName"
        />
        <StreamDonationOverviewPreviousDonation
          v-else
          :variation="chipVariation"
          :donation-style="donationStyle"
          :index="donation.previousIndex"
          :amount="donation.amount"
          :donor-name="donation.donorName"
        />
      </template>
    </div>

    <p class="kb-stream-donation-overview-horizontal__footer" v-html="footerText"></p>
  </article>
</template>
